var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable react/no-multi-comp */
import { connect } from 'react-redux';
import React from 'react';

import { logError } from "../utils";
import { Section } from "./Section";






const mapStateToProps = ({ templates, entityView }) => ({
  entity: entityView.entity,
  templates
});

const connector = connect(mapStateToProps);




const getPropertyValue = (property, metadataProperty) => {
  switch (property.type) {
    case 'multiselect':
    case 'multidaterange':
    case 'nested':
    case 'multidate':
    case 'geolocation':
      return metadataProperty.map((v) => v.label || v.value);
    case 'relationship':{
        let value = [];
        metadataProperty.forEach((v) => {
          if (v.inheritedType && v.inheritedValue) {
            const properties = getPropertyValue({ type: v.inheritedType }, v.inheritedValue);
            value = Array.isArray(properties) ? [...value, ...properties] : [...value, properties];
          } else {
            value.push(v.label || v.value);
          }
        });
        return Array.from(new Set(value));
      }
    case 'generatedid':
      return typeof metadataProperty === 'string' ? metadataProperty : metadataProperty[0].value;
    default:
      return Array.isArray(metadataProperty) && metadataProperty.length > 0 ?
      metadataProperty[0].label || metadataProperty[0].value :
      undefined;
  }
};

// eslint-disable-next-line import/exports-last
export const UnwrapMetadataObject = (MetadataObject, Template) =>
Object.keys(MetadataObject).reduce((UnwrapedMO, key) => {
  if (!MetadataObject[key].length) {
    return UnwrapedMO;
  }
  const property = Template.properties.find((p) => p.name === key);
  const propertyValue = getPropertyValue(property, MetadataObject[key]);
  return _objectSpread(_objectSpread({}, UnwrapedMO), {}, { [key]: propertyValue });
}, {});

// eslint-disable-next-line max-statements
const EntitySection = ({ entity, templates, children, 'show-if': showIf }) => {
  const jsEntity = entity.toJS();
  const template = templates.find((t) => (t === null || t === void 0 ? void 0 : t.get('_id')) === jsEntity.template);
  const unwrappedMetadata = UnwrapMetadataObject(jsEntity.metadata, template.toJS());
  jsEntity.metadata = unwrappedMetadata;
  try {
    const condition = JSON.parse(showIf);
    return /*#__PURE__*/(
      _jsx(Section, { data: [jsEntity], showIf: condition }, void 0,
      children
      ));

  } catch (e) {
    logError(e, showIf);
    return null;
  }
};

const container = connector(EntitySection);
export { container as EntitySection };